import { LeasesBasicDetails, LeasesNav } from '../../elements';
import InvoiceHeaderConfig from '../components/InvoiceHeaderConfig';
import BusinessDaysConfig from '../components/BusinessDaysConfig';
import ManagementFeeConfiguration from '../components/ManagementFeeConfiguration';
import { Grid, Paper } from '@mui/material';
import BackToLeaseList from '../../elements/BackToLeaseList';
import { gaTelesisInstance } from '../../../shared_elements';
import { useEffect } from 'react';
import { trackActivity } from '../../../utils/mixpanel';

const LeaseSettings = () => {

  useEffect(() => {
    trackActivity('Page Viewed', { page_title: 'Lease Settings' })
  }, []);

  return (
    <>
      <LeasesBasicDetails />
      <Paper className='lease-details-section lease-nav-module-margin lease-module-paper' elevation={0}>
        <LeasesNav />
        <div className='lease-details-content lease-content-overflow'>
          <Paper square className="responsive-paper">
            <Grid container spacing={1} className="responsive-grid" alignItems='flex-end'>
              <Grid item md={4} xs={12} className="menu-container lease-list-link-mt">
                <BackToLeaseList />
              </Grid>
              <Grid item md={8} xs={12} mb={1}></Grid>
            </Grid>
          </Paper>
          <div className='lease-detail-table' style={{ overflowY: 'auto', height: 'calc(100vh - 200px)', padding: '3px' }}>
            <BusinessDaysConfig />
             <ManagementFeeConfiguration /> 
            {gaTelesisInstance && <InvoiceHeaderConfig />}
          </div>
        </div>
      </Paper>
    </>
  );
};

export default LeaseSettings;
